import { Outlet } from 'react-router-dom';
import '../../styles/student/student-layout.css';
import '../../styles/student/student-components.css';

export default function StudentLayout() {
  return <Outlet />;
}
